import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit, Optional } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EVENTS } from '@app/constants/events.constants';
import { BsFileUploadComponent } from '@app/modules/bs-file-upload/bs-file-upload.component';
import { loginStoreActions, RootStoreState } from '@app/root-store';
import { AuthService, LoaderService, UserService } from '@app/shared/services';
import { Store } from '@ngrx/store';
import PhoneNumber from 'awesome-phonenumber';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, Observable, Subscription, timer } from 'rxjs';
import { ISO_3166_1_CODES } from './country-codes';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'multifactor-authentication',
  templateUrl: './multifactor-authentication.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MultifactorAuthenticationComponent implements OnInit, OnDestroy {
  @Input() fromSetup = false;
  countyCodes = ISO_3166_1_CODES;
  apiIsInprogress = false;
  multiFactorAuthStep1 = true;
  enableMfaInprogress = false;
  multiFactorAuthStep2 = false;
  hiddenPhoneNumber = '*****';
  multiFactorAuthStep3 = false;
  subscription = new Subscription();
  counter = 1800;
  tick = 1000;
  errCode$ = false;
  verification_code_Data;
  profileForm = this.fb.group({
    phone: this.fb.group(
      {
        country: ['US'],
        number: [''],
      },
      { validators: phoneValidator }
    ),
  });
  googleUser: any;
  isGoogleUser: any;
  verificationCompleted = false;
  transform(value: number): string {
    //MM:SS format
    const minutes: number = Math.floor(value / 60);
    return ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);

    // for HH:MM:SS
    //const hours: number = Math.floor(value / 3600);
    //const minutes: number = Math.floor((value % 3600) / 60);
    //return ('00' + hours).slice(-2) + ':' + ('00' + minutes).slice(-2) + ':' + ('00' + Math.floor(value - minutes * 60)).slice(-2);
  }

  phoneErrorMatcher = new PhoneErrorMatcher();

  // get screen viewport
  screenWidth: number;
  resizeObservable$: Observable<Event>;

  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private authService: AuthService,
    private toastr: ToastrService,
    private fb: UntypedFormBuilder,
    private _userService: UserService,
    private store$: Store<RootStoreState.State>,
    @Optional() public dialogRef: MatDialogRef<MultifactorAuthenticationComponent>,
    private cd: ChangeDetectorRef,
    private loaderService: LoaderService,
    private loginService: LoginStoreEffects
  ) {}

  ngOnInit() {
    this.screenWidth = window.innerWidth;

    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );
    this.subscription.add(
      this.loginService.loginObject.subscribe((state) => {
        const user = state?.data;

        if (user?.id) {
          this.googleUser = user;
          this.isGoogleUser = user?.cognito_id_email?.includes('google');
        }
      })
    );
    this.subscription.add(
      timer(0, this.tick).subscribe(() => {
        --this.counter;
        if (this.counter <= 0) {
          this.counter == 0;
        }
        this.cd.detectChanges();
      })
    );
  }

  get phoneGroup() {
    return this.profileForm.get('phone') as UntypedFormControl;
  }

  get phoneCountryControl() {
    return this.profileForm.get('phone.country') as UntypedFormControl;
  }

  get phoneNumberControl() {
    return this.profileForm.get('phone.number') as UntypedFormControl;
  }

  get phoneNumberDigits(): string {
    return this.phoneNumberControl.value.replace(/\D/g, '');
  }

  get phoneNumber(): PhoneNumber {
    return new PhoneNumber(this.phoneNumberDigits, this.phoneCountryControl.value);
  }

  get phoneHint(): string {
    return PhoneNumber.getExample(this.phoneCountryControl.value).getNumber('national');
  }

  get phoneE164(): string {
    return this.phoneNumber.getNumber('e164');
  }

  formatNumber() {
    const natNum = this.phoneNumber.getNumber('national');
    this.phoneNumberControl.setValue(natNum ? natNum : this.phoneNumberDigits);
  }

  async verifyUserPhoneNumber() {
    this.loaderService.show();
    if (!this.profileForm.valid) {
      this.toastr.error('failed to send verification code');
      this.loaderService.hide();
      return;
    }
    let phone_number = this.phoneNumber.getNumber();
    const last = phone_number.slice(-4);
    this.hiddenPhoneNumber = '+******' + last.toString();
    //update phone number
    this.apiIsInprogress = true;

    this.cd.detectChanges();
    if (await this.authService.updateCurrentUserAttributes({ phone_number: phone_number })) {
      this.cd.detectChanges();
      //if sucessfull, send verification code
      const results = await this.authService.sendUserPhoneNumberVerification();
      if (!results.success) {
        this.toastr.error('Unable to configure 2 factor authentication');
        this.loaderService.hide();

        this.cd.detectChanges();
      } else {
        this.counter = 150;
        this.multiFactorAuthStep1 = false;
        this.multiFactorAuthStep2 = true;
        this.errCode$ = false;
        this.toastr.success('We have sent you a verification code');
        this.loaderService.hide();

        this.cd.detectChanges();
      }
    } else {
      this.toastr.error('Unable to configure 2 factor authentication');
      this.loaderService.hide();

      this.cd.detectChanges();
    }
  }
  onOtpChange(event) {
    this.verification_code_Data = event;
  }
  async enableMFA() {
    let verification_code = this.verification_code_Data;
    this.enableMfaInprogress = true;
    this.loaderService.show();
    this.cd.detectChanges();
    const results = await this.authService.confirmUserPhoneNumber(verification_code);
    this.enableMfaInprogress = false;
    this.cd.detectChanges();
    if (results.success) {
      const dataObj = {
        mfa_enabled: true,
      };
      this.subscription.add(
        this._userService.updateUser(dataObj).subscribe(async (res) => {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
          this.multiFactorAuthStep2 = false;
          this.multiFactorAuthStep3 = false;
          this.verificationCompleted = true;

          //phone has been verified, enable MFA
          if (await this.authService.enableCurrentUserMFA('sms')) {
            this.loaderService.hide();
            this.enableMfaInprogress = false;
            this.multiFactorAuthStep2 = false;
            if (this.data.hasStep) this.addProfilePicture();
            this.verificationCompleted = true;
            this.cd.detectChanges();
            this.saveData(true);
            this.toastr.success('Two Factor Authentication Set Up');
            this._userService.trackEventsInMixPanel([{ eventName: EVENTS.security_privacy_2fa_change }]).then((response) => {});
          } else {
            this.enableMfaInprogress = false;
            this.errCode$ = true;
            this.cd.detectChanges();
            this.toastr.error('unable to configure 2FA');
            this.loaderService.hide();
          }
        })
      );
    } else {
      this.enableMfaInprogress = false;
      this.errCode$ = true;
      this.loaderService.hide();
      this.cd.detectChanges();
      // this.toastr.error('unable to configure 2FA');
    }
  }

  saveData(value) {
    const dataObj = {
      mfa_enabled: value,
    };
    this.subscription.add(
      this._userService.updateUser(dataObj).subscribe(
        (res) => {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());

          this.cd.detectChanges();
        },
        (error) => {
          this.cd.detectChanges();
        }
      )
    );
  }
  SkipForclosedialog() {
    this.dialogRef.close({ skipForNow: true });
  }
  closeDialog() {
    this.dialogRef.close(this.verificationCompleted);
  }
  async disableMFA() {
    if (await this.authService.disableCurrentUserMFA('SMS')) {
      this.toastr.success('2FA disabled');
    }
  }

  addProfilePicture() {
    this.dialog.closeAll();
    const modalRef2 = this.dialog.open(BsFileUploadComponent, {
      data: { type: 'profile', title: 'Upload Profile Picture', triggeredFrom: 'continueBtn' },
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });
    this.subscription.add(
      modalRef2.afterClosed().subscribe((data) => {
        if (data) {
          this.store$.dispatch(new loginStoreActions.LoginRequestAction());
          // this.toastr.success('Profile image updated');
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
    this._userService.cleanupWorker();
  }
}
export const phoneValidator: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
  const num = control.get('number');
  const country = control.get('country');
  if (num.value && country.value && !new PhoneNumber(num.value, country.value).isValid()) {
    return { invalidPhone: true };
  } else {
    return null;
  }
};

export class PhoneErrorMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control.value && control.touched && !control.parent.valid);
  }
}
